// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  UhdLists,
  UhdListsData,
  UhdListsPatch,
  UhdListsQuery,
  UhdListsService,
} from './uhd-lists.class';

export type { UhdLists, UhdListsData, UhdListsPatch, UhdListsQuery };

export type UhdListsClientService = Pick<UhdListsService, (typeof uhdListsMethods)[number]>;

export const uhdListsPath = 'api/uhd-lists';

export const uhdListsMethods: Array<keyof UhdListsService> = [
  'patch',
  'remove',
  'addExistingFilm',
  'addNewFilm',
  'getListWithMetadata',
  'getMultipleLists',
  'getMultipleListsMetadata',
  'getUnifiedLists',
];

export const uhdListsClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(uhdListsPath, connection.service(uhdListsPath), {
    methods: uhdListsMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [uhdListsPath]: UhdListsClientService;
  }
}
